<template lang="pug">
.realtime-container(ref='container')
  .realtime-scada(ref='canvas')
</template>

<style lang="scss">
.realtime-container {
  width: 100%;
  height: 100%;

  .realtime-scada {
    margin-top: 30px;
    display: flex;
    justify-content: center;
  }
}
</style>

<script>
import Konva from 'konva'
export default {
  props: {
    gcpToggleAutomaticStatus: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      stage: null,
      canvasWidth: null,
      canvasHeight: null,
      pipeline_layer: null,
      flow_layer: null,
      device_layer: null,

      // 管線
      piplines: [
        {
          obj: null,
          src: require('@/assets/video/scada/img_3dfield_powerflow_s.svg'),
          w: 400,
          h: 950
        }
      ],

      // 設備
      device: [
        { obj: null, x: 245, y: 114, w: 96, h: 48, type: 'flow_meter', status: 'normal', rotate: 0, name: 'FT1' },
        { obj: null, x: 15, y: 280, w: 50, h: 80, type: 'bypass', status: 'normal', rotate: 0, name: 'MO4' },

        { obj: null, x: 261, y: 220, w: 50, h: 80, type: 'bypass', status: 'normal', rotate: 0, name: 'MO1' },
        { obj: null, x: 261, y: 330, w: 50, h: 80, type: 'bypass', status: 'normal', rotate: 0, name: 'MO2' },
        { obj: null, x: 266, y: 440, w: 88, h: 48, type: 'mano_meter', status: 'normal', rotate: 0, name: 'FT4' },
        { obj: null, x: 253, y: 510, w: 140, h: 176, type: 'waterwheel', status: 'normal', rotate: 0, name: '水車' },
        { obj: null, x: 335, y: 700, w: 50, h: 80, type: 'bypass', status: 'normal', rotate: 0, name: 'MO3' }
      ],
      valveHandle: [
        { obj: null, x: 15 + 25, y: 295 + 25, w: 50, h: 50, offsetX: 25, offsetY: 25, type: 'bypass_handle', status: 'normal', rotate: 180 },
        { obj: null, x: 261 + 25, y: 235 + 25, w: 50, h: 50, offsetX: 25, offsetY: 25, type: 'bypass_handle', status: 'normal', rotate: 0 },
        { obj: null, x: 261 + 25, y: 345 + 25, w: 50, h: 50, offsetX: 25, offsetY: 25, type: 'bypass_handle', status: 'normal', rotate: 0 },
        { obj: null, x: 335 + 25, y: 715 + 25, w: 50, h: 50, offsetX: 25, offsetY: 25, type: 'bypass_handle', status: 'normal', rotate: 0 }
      ],
      // 水流
      energy_flow: null,
      normal_flow: null,

      /**
       * 圖片路徑
       */
      image: {
        flow_meter: require('@/assets/scada/img_asset_valve_flow_meter.svg'),
        mano_meter: require('@/assets/scada/img_asset_valve_manometer.svg'),
        bypass: require('@/assets/scada/img_asset_valve_joint.svg'),
        bypass_handle: require('@/assets/scada/img_asset_valve.svg'),
        waterwheel: require('@/assets/video/scada/img_asset_waterwheel_s.svg'),
        dynamo: require('@/assets/scada/power-motor.svg')
      }
    }
  },
  mounted () {
    this.initStage()
  },
  methods: {
    initStage () {
      const canvas = this.$refs.canvas

      const scale = 1
      this.canvasWidth = 400 * scale
      this.canvasHeight = 950 * scale

      this.stage = new Konva.Stage({
        container: canvas,
        width: this.canvasWidth,
        height: this.canvasHeight
      })

      this.pipeline_layer = new Konva.Layer()
      this.flow_layer = new Konva.Layer()
      this.device_layer = new Konva.Layer()

      this.stage.add(this.pipeline_layer)
      this.stage.add(this.flow_layer)
      this.stage.add(this.device_layer)

      this.addWaterFlow()
      this.addPipline()
      this.addDevice()
      this.addValveHandle()
    },
    showWaterFlow () {
      const tween = new Konva.Tween({
        node: this.energy_flow,
        duration: 1,
        easing: Konva.Easings.EaseInOut,
        opacity: 1
      })
      tween.play()
    },
    addWaterFlow () {
      const energyLine = new Konva.Line({
        points: [
          0, 0,
          242, 0,
          242, 116,
          206, 116,
          206, 520,
          281, 520,
          281, 750,
          -40, 750,
          -40, 846,
          281, 846
        ],
        stroke: '#ffeb00',
        strokeWidth: 8,
        lineCap: 'round',
        lineJoin: 'round',
        dash: [10, 18],
        visible: false,

        shadowColor: 'black',
        shadowOpacity: 0.4,
        shadowBlur: 5,
        shadowOffset: { x: 0, y: 1 }
      })
      energyLine.move({ x: 80, y: 70 })
      this.energy_flow = energyLine
      this.flow_layer.add(this.energy_flow)

      const normalLine = new Konva.Line({
        points: [
          0, 0,
          242, 0,
          242, 116,
          -40, 116,
          -40, 846,
          285, 846
        ],
        stroke: '#96ffff',
        strokeWidth: 8,
        lineCap: 'round',
        lineJoin: 'round',
        dash: [10, 18],
        visible: true,

        shadowColor: 'black',
        shadowOpacity: 0.4,
        shadowBlur: 5,
        shadowOffset: { x: 0, y: 1 }
      })
      normalLine.move({ x: 80, y: 70 })
      this.normal_flow = normalLine
      this.flow_layer.add(this.normal_flow)

      let i = 0
      const anim = new Konva.Animation(function (frame) {
        i += 0.5
        energyLine.dashOffset(-(i))
        normalLine.dashOffset(-(i))
      }, this.line_layer)

      anim.start()
    },
    addPipline () {
      const _this = this

      for (const i in this.piplines) {
        const pipline = this.piplines[i]

        const imageObj = new Image()
        imageObj.src = pipline.src

        imageObj.onload = function () {
          pipline.obj = new Konva.Image({
            x: 0,
            y: 0,
            image: imageObj,
            width: pipline.w,
            height: pipline.h
          })
          _this.pipeline_layer.add(pipline.obj)
        }
      }
    },
    addDevice () {
      const _this = this

      for (const d of this.device) {
        const img = new Image()

        img.onload = function () {
          d.obj = new Konva.Image({
            x: d.x,
            y: d.y,
            image: img,
            width: d.w,
            height: d.h,
            rotation: d.rotate,
            opacity: 1
          })
          _this.device_layer.add(d.obj)
        }
        img.src = this.image[d.type]
      }
    },
    addValveHandle () {
      const _this = this
      for (const d of this.valveHandle) {
        const img = new Image()

        img.onload = function () {
          d.obj = new Konva.Image({
            x: d.x,
            y: d.y,
            image: img,
            width: d.w,
            height: d.h,
            rotation: d.rotate,
            offsetX: d.offsetX,
            offsetY: d.offsetY
          })
          _this.device_layer.add(d.obj)
        }
        img.src = this.image[d.type]
      }
    }
  },
  watch: {
    gcpToggleAutomaticStatus (newVal) {
      // true: 發電水流 / false: 原水流
      this.normal_flow.visible(!newVal)
      this.energy_flow.visible(newVal)
    }
  }
}
</script>
